import {Component, Prop, Vue, Emit} from 'vue-property-decorator';
import Service from '../../../../common/src/assets/service/service';
import Common from '../../../../common/src/assets/js/common';
import Constant from '../../../../common/src/assets/constant/constant';
// @ts-ignore
import jsencrypt from '../../../../common/src/assets/encryption/jsencrypt/jsencrypt.min.js';
import LoginHeader from '../../components/login-header/login-header.vue';
import common from "../../../../common/src/assets/js/common";
import service from "../../../../common/src/assets/service/service";
import authority from "../../../../common/src/assets/authority/authority";
import LoginFooter from "../../components/login-footer/login-footer.vue";

declare var $: any;
@Component({
    components: {
        LoginHeader,
        LoginFooter
    }
})
export default class Login extends Vue {
    private $store: any;
    private $router: any;
    private $route: any;
    private $layer: any
    private apiUrl: string = Service.apiPrefix;
    private toPath: string = '/general';
    private path: string = '';

    private status: any = {
        name: '',
        password: '',
        vscode: '',
        loading: '',
        showVscode: false,
        sign: '',
        colorJson: '',
    }
    private loading: any = {
        echart: ''
    }
    private errorMsg: any = {
        name: '',
        password: '',
        vscode: '',
    }

    private tplRegisterSetting: any = 1; // 是否开启注册
    private newTime = new Date().getTime();
    private oldTime = new Date().getTime();
    private outTime = 1 * 60 * 60 * 1000; // 超时时间 1h
    // private outTime = 60 * 1000; // 超时时间 1h

    created() {
        // 获取ecp新代理商 跳转过来的token
        let params = this.$route.query;
        this.path = params?.path
        let queryUserID = params?.userID;
        let queryToken = params?.ewalkToken;
        let userID:any;
        let token:any;

        if (params && queryUserID && queryToken) {
            userID = queryUserID;
            token = queryToken;
            let date = new Date();
            // date.setTime(date.getTime() + Constant.userCookie); // 1d过期
            date.setTime(date.getTime() + (1 * 60 * 60 * 1000)); // 1h过期
            Common.setCookie('front_userID', queryUserID, date)
            Common.setCookie('front_ewalkToken', queryToken, date);
            this.getAuthority(userID)
            this.$router.push(this.toPath);
            return;
        }
        if (!Common.getCookie('front_userID')) {
            userID = Common.getUserID('ecp');
            token = Common.getCookie('front_ewalkToken');
        }
        if (userID && token) {
            this.$layer.msg('您当前为登录状态，勿需重复登录！', {type: 'warning'});
            setTimeout(() => {
                this.$router.push(this.toPath);
            }, 2000)
            return;
        }
        this.setColorJson();
        // this.getToken();
    }

    mounted() {
        this.getAuthority()
        let userID = Common.getUserID('ecp');
        let token = Common.getCookie('front_ewalkToken');
        if (userID && token) {
            let params = this.$route.query;
            if (!params.userID) {
                this.$layer.msg('您当前为登录状态，勿需重复登录！', {type: 'warning'});
            }
            this.$router.push(this.toPath);
        }
    }

    private getToken() {
        Service.request('/CreateToken', {userID: 'EW_VISITOR'}, 'original').then((res: any) => {
            Common.setCookie('front_ewalkToken', res.data);
        }).catch((error: any) => {

        })
    }

    /**检查输入框 */
    private checkInput(type: string, show: boolean = true) {
        switch (type) {
            case 'name':
                this.errorMsg.name = this.status.name.trim() === '' ? '请输入账号' : '';
                break;
            case 'password':
                this.errorMsg.password = this.status.password.trim() === '' ? '请输入密码' : '';
                break;
            case 'vscode':
                this.errorMsg.vscode = this.status.showVscode && this.status.vscode.trim() === '' ? '请输入验证码' : '';
                break;
        }
        if (this.errorMsg[type] && show) {
            this.$layer.msg(this.errorMsg[type], {type: 'error'});
        }
        return this.errorMsg[type] === '';
    }

    private inputBlur() {
        if (this.checkInput('name', false) === false) {
            return;
        }
        this.checkVscode();
    }

    /**登录 */
    private login() {
        if (this.checkInput('name') === false || this.checkInput('password') === false || this.checkInput('vscode') === false || this.status.loading === 'loading') {
            return false;
        }

        /**加密账号密码 */
        let publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC3R2oMsiDws1jzuUxSfkaasNr/ZFsFER7Qn3ZC8uRwHgV+KQBMk//STuEvoYf0d+axg2T4xdJ/drjcIdQgGXn+xqYVfN88FYsHn3TTjoZ9/OS1nmVpnax/LIX77FwBghSC1YDHU9a006y71k1SnldtnW5FJ2uRM/KsdSOuIkPkFQIDAQAB';
        let encrypt = new jsencrypt();
        encrypt.setPublicKey(publicKey);
        let params = {
            account: encrypt.encrypt(this.status.name),
            password: encrypt.encrypt(this.status.password),
            imageCodeSign: this.status.sign,
            imageCode: this.status.vscode,
        }
        this.status.loading = 'loading';
        Service.request('/user/login', params, 'token')
            .then((res: any) => {
                this.status.loading = 'havedata';
                let data = res.data;

                let date = new Date();
                // date.setTime(date.getTime() + Constant.userCookie); // 1d过期
                // date.setTime(date.getTime() + (1 * 60 * 60 * 1000)); // 2h过期
                date.setTime(date.getTime() + (1 * 60 * 60 * 1000)); // 2h过期
                Common.setCookie('front_userID', data.customerInfo.userID, date)
                Common.setCookie('user', data.customerInfo.email, date)
                Common.setCookie('front_ewalkToken', data.ewalkToken, date);
                    // 监听鼠标长时间不操作
                    // @ts-ignore
                    document.addEventListener('mousemove', this.changeCookieTime(data.customerInfo.userID, data.ewalkToken, data.customerInfo.email))
                    let timer =  window.setInterval(() => {
                        this.newTime = new Date().getTime();
                        if (this.newTime - this.oldTime > this.outTime) { // 到时间
                            this.$layer.msg('您已长时间没有操作，请重新登录！', {type: 'warning'});
                            window.clearInterval(timer);
                            setTimeout(() => {
                                // @ts-ignore
                                document.removeEventListener('mousemove', this.changeCookieTime('', '', ''))
                                this.$router.push({path: '/login'});
                            }, 2000)
                        }
                    }, 3000)
                this.getAuthority();
                console.log(this.toPath)
                if (this.path) {
                    this.$router.push(this.path);
                } else {
                    this.$router.push(this.toPath);
                }
            })
            .catch(error => {
                this.status.loading = 'nodata';
                this.$layer.msg(error.errorMsg, {type: 'error'});
                this.checkVscode();
            });
    }
        /**监听鼠标长时间不操作 */
        private changeCookieTime(userID:any, ewalkToken:any, email?:any) {
            let that = this;
            let date = new Date();
            that.oldTime = date.getTime();
            date.setTime(date.getTime() + that.outTime); // 2h
            Common.setCookie('front_userID', userID, date)
            Common.setCookie('user', email, date)
            Common.setCookie('front_ewalkToken', ewalkToken, date);
        }
    /**
     * 获取前台权限
     */
    private getAuthority(userID?:any) {
        let params = {
            userID: common.getUserID('ecp') || userID,
        }
        service.request('/user/agentConfig/getSystemInfo', params,).then((res: any) => {
            authority.getAuthority('superAdmin', res.data.resourceFunction)
            this.tplRegisterSetting = res.data['tplRegisterSetting'];
            this.$store.commit('setSystemInfo', res.data || {});
        }).catch((error: any) => {
            authority.getAuthority([]);
        })
    }

    /**检查是否需要输入验证码 */
    private checkVscode() {
        let params = {
            account: this.status.name
        }
        Service.request('/common/getNeedImageCode', params, 'token')
            .then((res: any) => {
                this.status.showVscode = res.data;
                if (!res.data) {
                    this.status.vscode = '';
                } else {
                    this.changeVscode();
                }
            })
            .catch(error => {
                // this.$layer.msg(error.errorMsg, {type: 'error'})
            });
    }

    /**改变验证码 */
    private changeVscode() {
        this.status.sign = +new Date();
    }

    /**验证码颜色 */
    private setColorJson() {
        let color = {
            bgR: '235',
            bgG: '242',
            bgB: '250',
            fontR: '68',
            fontG: '97',
            fontB: '146',
            lineR: '143',
            lineG: '152',
            lineB: '185',
        }
        this.status.colorJson = JSON.stringify(color);
    }

    private skip(url: string) {
        this.$router.push(url);
    }

}
